import { Grid, IconButton, Popover, Typography } from "@material-ui/core";
import StarFilled from "../assets/ratingFilled.svg";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

const InfoPopup = (props) => {
  const { anchorEl, setAnchorEl } = props;
  const open = Boolean(anchorEl);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const t = props.t;

  return (
    <>
      <Popover
        open={open}
        PaperProps={{
          style: {
            borderRadius: "15px",
            border: "solid 1.5px #808080",
            backgroundColor: "#fff",
            position: "relative",
            marginTop: isDesktopOrLaptop ? "10vh" : 0,
            marginLeft: isDesktopOrLaptop ? "25vw" : 0,
            marginRight: isDesktopOrLaptop ? "25vw" : 0,
            overflow: "scroll",
            maxHeight: "80vh",
          },
          className: "invisible-scrollbar",
        }}
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: 0.81, zIndex: -1 },
        }}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <div
          style={{
            paddingLeft: "35px",
            paddingRight: "21px",
            paddingBottom: "35px",
          }}
        >
          <Grid
            container
            style={{
              height: "40px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setAnchorEl(null);
                }}
              >
                <CloseIcon fontSize="small" style={{ color: "#808080" }} />
              </IconButton>
            </Grid>
          </Grid>
          <Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={StarFilled} alt="star" width="17px"></img>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "16px",
                  fontFamily: "Overpass",
                  color: "#16063b",
                  paddingLeft: "14px",
                }}
              >
                {t("fair_price")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  color: "#808080",
                  paddingTop: "14px",
                }}
              >
                {t("param1")}
              </Typography>
            </Grid>
          </Grid>

          <Grid style={{ paddingTop: "50px" }}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={StarFilled} alt="star" width="17px"></img>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "16px",
                  fontFamily: "Overpass",
                  color: "#16063b",
                  paddingLeft: "14px",
                }}
              >
                {t("potential")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  color: "#808080",
                  paddingTop: "14px",
                }}
              >
                {t("param2")}
              </Typography>
            </Grid>
          </Grid>

          <Grid style={{ paddingTop: "50px" }}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={StarFilled} alt="star" width="17px"></img>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "16px",
                  fontFamily: "Overpass",
                  color: "#16063b",
                  paddingLeft: "14px",
                }}
              >
                {t("past_history")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  color: "#808080",
                  paddingTop: "14px",
                }}
              >
                {t("param3")}
              </Typography>
            </Grid>
          </Grid>
          <Grid style={{ paddingTop: "50px" }}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={StarFilled} alt="star" width="17px"></img>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "16px",
                  fontFamily: "Overpass",
                  color: "#16063b",
                  paddingLeft: "14px",
                }}
              >
                {t("solvency")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  color: "#808080",
                  paddingTop: "14px",
                }}
              >
                {t("param4")}
              </Typography>
            </Grid>
          </Grid>
          <Grid style={{ paddingTop: "50px" }}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", alignItems: "center" }}
            >
              <img src={StarFilled} alt="star" width="17px"></img>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontWeight: 800,
                  fontSize: "16px",
                  fontFamily: "Overpass",
                  color: "#16063b",
                  paddingLeft: "14px",
                }}
              >
                {t("earnings")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  color: "#808080",
                  paddingTop: "14px",
                }}
              >
                {t("param5")}
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Popover>
    </>
  );
};

export default InfoPopup;
